import { Tag } from 'antd';

const labels: Record<string, string> = {
  success: 'Réussi',
  failure: 'Échec',
  failed: 'Échec',
  passed: 'Validé',
  pending: 'En attente',
  in_progress: 'En cours',
  completed: 'Terminé',
  not_run: 'Non exécuté',
  skipped: 'Non exécuté',
  available: 'Disponible',
  missing: 'Absent',
  invalid: 'Invalide',
  partial: 'Incomplet',
  unknown: 'Non vérifié',
  expired: 'Expiré',
  cancelled: 'Annulé',
  timed_out: 'Délai dépassé',
};
export default function E2EStatus({ status }: { status?: string }) {
  const value = status ?? 'unknown';
  return (
    <Tag
      color={
        ['success', 'passed', 'available'].includes(value)
          ? 'green'
          : ['failure', 'failed', 'invalid'].includes(value)
          ? 'red'
          : ['pending', 'in_progress'].includes(value)
          ? 'blue'
          : 'default'
      }
    >
      {labels[value] ?? value}
    </Tag>
  );
}
